/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from 'react';
import { PageAnnouncementWrapper } from './src/components/composite/landing/PageAnnouncementWrapper';
import './src/global/reset.css';

const addScript = (url) => {
  const script = document.createElement('script');
  script.src = url;
  script.async = true;
  document.body.appendChild(script);
};

export const onClientEntry = () => {
  window.onload = () => {
    // this script loading is required with React useEfect usage
    // - either for prod build process, on navigating with reach-router in rehidrated Gatsby mode
    // - or in dev mode, when we have everything dynamic
    addScript('https://widget.clutch.co/static/js/widget.js');
  };
};

/**
 * Wrap all pages with the rebranding announcement.
 * This intercepts ALL routes including dynamically generated pages.
 * Pages under /charts are excluded from the overlay.
 */
export const wrapPageElement = ({ element, props }) => {
  const path = props?.location?.pathname || '';
  const isChartsPage = path.startsWith('/charts') || path.match(/^\/(en|de|fr)\/charts/);

  if (isChartsPage) {
    return element;
  }

  return <PageAnnouncementWrapper element={element} />;
};
